import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';


import Homepage from './pages/Homepage';
import Aboutpage from './pages/Aboutpage';
import Contactpage from './pages/Contactpage';
import Servicepage from './pages/Servicepage';
import Gallerypage from './pages/Gallerypage';
import Termspage from './pages/Termspage';
import Privacypage from './pages/Privacypage';



// ScrollToTop
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// GAHandler


const App = () => {


  return (
    <>
      <ScrollToTop />




      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about-us" element={<Aboutpage />} />
        <Route path="/contact" element={<Contactpage />} />
        <Route path="/Service" element={<Servicepage />} />
        <Route path="/Projects" element={<Gallerypage />} />


           <Route path="/terms" element={<Termspage />} />
              <Route path="/privacy" element={<Privacypage />} />

      </Routes>
    </>
  );
};

export default App;